"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22,5457,9994],{

/***/ 15457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .333A6.667 6.667 0 1 0 13.668 7 6.674 6.674 0 0 0 7.001.333ZM7 13a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M9.765 5.097 6.237 8.626a.333.333 0 0 1-.472 0L4.237 7.097a.334.334 0 0 0-.472.472l1.528 1.528a1 1 0 0 0 1.415 0l3.529-3.528a.334.334 0 1 0-.472-.472Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCheckmarkCircle);

/***/ }),

/***/ 9994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgNoDisponible = function SvgNoDisponible(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M6.693 0c1.825 0 3.484.719 4.701 1.936 1.217 1.217 1.936 2.876 1.936 4.757a6.604 6.604 0 0 1-1.936 4.701 6.604 6.604 0 0 1-4.701 1.936c-1.88 0-3.54-.719-4.757-1.936A6.604 6.604 0 0 1 0 6.693c0-1.88.719-3.54 1.936-4.757C3.153.719 4.812 0 6.693 0Zm4.259 2.378a5.977 5.977 0 0 0-4.26-1.77c-1.714 0-3.207.664-4.314 1.77-1.106 1.107-1.77 2.6-1.77 4.315 0 1.66.664 3.152 1.77 4.259 1.107 1.106 2.6 1.77 4.315 1.77 1.66 0 3.152-.664 4.259-1.77a5.977 5.977 0 0 0 1.77-4.26c0-1.714-.664-3.207-1.77-4.314Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M4.083 4.525a.336.336 0 0 1 0-.442c.11-.11.332-.11.442 0l2.268 2.323 2.323-2.323c.11-.11.332-.11.443 0 .11.11.11.332 0 .442L7.236 6.85l2.323 2.267c.11.11.11.332 0 .443a.336.336 0 0 1-.443 0L6.793 7.236 4.525 9.559a.336.336 0 0 1-.442 0 .336.336 0 0 1 0-.443L6.406 6.85 4.083 4.525Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgNoDisponible);

/***/ }),

/***/ 10022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ price_detail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
;// CONCATENATED MODULE: ./public/assets/domainBrand/logo-prices-primary.png
/* harmony default export */ var logo_prices_primary = ({"src":"/_next/static/media/logo-prices-primary.98f81389.png","height":526,"width":1175,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEVMaXEJOzEJNjMJNjIINCwINTEJNjIdjAIIAAAAB3RSTlMAGCE8C1qDxA2jpgAAAAlwSFlzAAAPYQAAD2EBqD+naQAAACFJREFUeJxjYGJhgAA2VmZmJmZmRgY2VkZGRkYmFgaYFAAEqAA8vyKjcgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./public/assets/icons/CheckmarkCircle.svg
var CheckmarkCircle = __webpack_require__(15457);
// EXTERNAL MODULE: ./public/assets/icons/NoDisponible.svg
var NoDisponible = __webpack_require__(9994);
;// CONCATENATED MODULE: ./components/organisms/price-detail-card/PriceDetailCard.tsx








/**
 * PriceDetailCard
 */ var PriceDetailCard = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, beCasaPrice = param.beCasaPrice, traditionalPrice = param.traditionalPrice, detalles = param.detalles, _disclaimer = param.disclaimer, disclaimer = _disclaimer === void 0 ? "" : _disclaimer;
    var t = (0,useTranslation/* default */.Z)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        className: "flex w-fit ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "w-full text-primary-400",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        className: "border-b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-3/6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-1/& flex justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: logo_prices_primary,
                                        height: 36,
                                        width: 81,
                                        alt: "Logo Be Casa"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "flex w-1/3 justify-end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-body price_detail-traditional text-body--secondary",
                                        children: t("components.organisms.priceDetail.traditionalRenting")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        className: "flex flex-col",
                        children: detalles.map(function(element, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: "mt-3 flex flex-row items-center gap-2 ".concat(index + 1 !== detalles.length ? "border-b" : "", " border-primary-200"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        className: "flex w-3/6 flex-row items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                src: element.icon,
                                                height: 15,
                                                width: 15
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-body text-body--secondary flex justify-center",
                                                children: element.text
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "flex w-1/6 items-center justify-center",
                                        children: element.isInBeCasa ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircle["default"], {
                                            width: 14,
                                            heigth: 14
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDisponible["default"], {
                                            width: 14,
                                            heigth: 14
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "text-body text-body--secondary flex w-1/3 items-center justify-end pr-2 sm:pr-6",
                                        children: element.traditionalPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                element.traditionalPrice,
                                                " €"
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDisponible["default"], {
                                            className: "mr-[13px]",
                                            width: 14,
                                            heigth: 14
                                        })
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                        className: "mt-1 flex justify-between",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: "text-body price_detail-price text-body--secondary--bold",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    className: "ml-2 w-3/6",
                                    children: t("components.organisms.priceDetail.totalCost")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    className: "priceDetailFooter flex w-1/6 justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "w-fit",
                                            children: [
                                                beCasaPrice,
                                                "€"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "w-fit",
                                            children: [
                                                t("components.organisms.priceDetail.perMonth"),
                                                "*"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    className: "priceDetailFooter flex w-1/3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "w-fit",
                                            children: [
                                                traditionalPrice,
                                                "€"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "w-fit",
                                            children: [
                                                t("components.organisms.priceDetail.perMonth"),
                                                "*"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-other text-other--detail mt-6 text-primary-300",
                children: disclaimer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};
PriceDetailCard.displayName = "PriceDetailCard";

;// CONCATENATED MODULE: ./components/organisms/price-detail-card/index.ts

/* harmony default export */ var price_detail_card = (PriceDetailCard);

;// CONCATENATED MODULE: ./components/templates/price-detail/PriceDetail.tsx





/**
 * PriceDetail
 */ var PriceDetail = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, backgroundColorBottom = param.backgroundColorBottom, backgroundColorBottomMobile = param.backgroundColorBottomMobile, backgroundColorTop = param.backgroundColorTop, backgroundColorTopMobile = param.backgroundColorTopMobile, caption = param.caption, cardProps = param.cardProps, _cutLevel = param.cutLevel, cutLevel = _cutLevel === void 0 ? 50 : _cutLevel, _cutLevelMobile = param.cutLevelMobile, cutLevelMobile = _cutLevelMobile === void 0 ? 50 : _cutLevelMobile, desc = param.desc, textColor = param.textColor, title = param.title, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        id: id,
        backgroundColorBottom: backgroundColorBottom,
        backgroundColorTopMobile: backgroundColorTopMobile,
        backgroundColorTop: backgroundColorTop,
        backgroundColorBottomMobile: backgroundColorBottomMobile,
        cutLevel: cutLevel === null ? 50 : cutLevel,
        cutLevelMobile: cutLevelMobile === null ? 50 : cutLevel,
        className: "flex  flex-col gap-5 md:flex-row md:gap-16 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                title: title,
                desc: desc,
                direction: "column",
                textAlign: "start",
                variant: textColor,
                caption: caption,
                className: "w-full justify-center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:w-full md:max-w-[500px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative left-3 top-7 z-10 h-[56px] w-[56px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/img/logo/logo_negativo.svg",
                            layout: "fill",
                            objectFit: "contain",
                            alt: "Logo BeCasa"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(price_detail_card, (0,_object_spread/* default */.Z)({}, cardProps))
                ]
            })
        ]
    });
};
PriceDetail.displayName = "PriceDetail";

;// CONCATENATED MODULE: ./components/templates/price-detail/index.ts

/* harmony default export */ var price_detail = (PriceDetail);


/***/ })

}]);